module.exports = __webpack_public_path__ + "static/img/wing_718.422ea5d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/products/wing_718.jpg
// module id = T1aD
// module chunks = 0